import { FlowBackArrow } from '@/components/backarrow';
import { Grid } from '@mui/material';
import { SafeSpacePadder, Transition } from '@repo/ui';

export default function StepWrapper({
  children,
}: {
  children: React.JSX.Element | React.JSX.Element[];
}): React.JSX.Element {
  return (
    <Transition id="step_wrapper_transition" style={{ display: 'flex', width: '100%', height: '100%' }}>
      <SafeSpacePadder>
        <Grid
          container
          sx={{
            flexDirection: 'column',
            flexWrap: 'nowrap',
            height: '100%',
            gap: 2,
            // Only the intro copy right under the step title reads larger: subtitle2 also labels cards and legal text
            '& h1 + .MuiTypography-subtitle2, & h1 + .MuiStack-root > .MuiTypography-subtitle2': {
              fontSize: '1rem',
              lineHeight: '1.5rem',
            },
          }}
        >
          <FlowBackArrow />
          {children}
        </Grid>
      </SafeSpacePadder>
    </Transition>
  );
}
